<ng-template #emptyState>
    <div class="empty-state-wrapper">
        <div class="empty-state">
            <span
                *ngIf="!anyActiveFilter"
                class="building-wrapper"
                hamIconShapes
                icon="assets/hamIcons/building.svg"
                [size]="'50px'"
            >
            </span>
            <span
                *ngIf="anyActiveFilter"
                class="building-wrapper"
                hamIconShapes
                icon="assets/hamIcons/exclamation-outline.svg"
                [size]="'50px'"
            >
            </span>

            <div class="text1" *ngIf="activeNav === navEnum.MY_PROJECTS && !anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_mandates' | i18next }}
            </div>
            <div class="text1" *ngIf="activeNav === navEnum.ALL_PROJECTS && !anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_companies' | i18next }}
            </div>
            <div class="text1" *ngIf="activeNav === navEnum.COMPANY && !anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_individual_company' | i18next }}
            </div>
            <div class="text1" *ngIf="anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_filtered_text1' | i18next }}
            </div>

            <div class="text2" *ngIf="activeNav === navEnum.MY_PROJECTS && !anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_assign_instructions' | i18next }}
            </div>

            <div class="text2" *ngIf="activeNav === navEnum.ALL_PROJECTS && !anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_create_instructions' | i18next }}
            </div>
            <div class="text2" *ngIf="activeNav === navEnum.COMPANY && !anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_create_instructions_individual_company' | i18next }}
            </div>
            <div class="text2" *ngIf="anyActiveFilter">
                {{ 'cpmm_projects_overview_empty_filtered_text2' | i18next }}
            </div>

            <ham-button
                *ngIf="activeNav === navEnum.MY_PROJECTS && !anyActiveFilter"
                type="submit"
                (buttonClick)="onGoToCompanies()"
            >
                {{ 'cpmm_projects_overview_empty_go_to_companies_button' | i18next }}
            </ham-button>

            <ham-button
                *ngIf="activeNav === navEnum.ALL_PROJECTS && !anyActiveFilter"
                type="submit"
                icon="assets/hamIcons/plus-outline.svg"
                (buttonClick)="onAddNewCompany()"
            >
                {{ 'cpmm_projects_overview_empty_add_new_company_button' | i18next }}
            </ham-button>
            <ham-button
                *ngIf="activeNav === navEnum.COMPANY && !anyActiveFilter"
                type="submit"
                [disabled]="disableNewProjectButtonEmptyState"
                icon="assets/hamIcons/plus-outline.svg"
                (buttonClick)="onAddNewProject()"
            >
                {{ 'aumico_projects_overview_add_new_project' | i18next }}
            </ham-button>
        </div>
    </div>
</ng-template>

<div class="empty-first-row-no-CPMM-overlay" *ngIf="groupedAreas?.length === 0"></div>

<ng-container *ngIf="projects && projects.length > 0; else emptyState">
    <div
        class="table-wrapper"
        [ngStyle]="{ '--table-width': totalTableLength + 'px' }"
        [class.noCPMM]="groupedAreas?.length === 0"
    >
        <ham-table-with-actions
            [dataSource]="filteredProjects"
            [pagination]="false"
            [columnClasses]="columnClasses"
            [tableStyles]="'overflow-x: auto;'"
            hideActions="true"
            showActionsInRowsOnly="true"
            (rowSelected)="onRowSelected($event)"
        >
            <!-- 🔵 Blue Group Header Row -->
            <tr groupHeaderRow class="group-header-row">
                <th class="stick-0"></th>
                <th class="middle-cols-MM col1" [class.noCPMM]="groupedAreas?.length === 0"></th>

                <th
                    class="middle-cols-MM col2"
                    *ngIf="activeNav !== navEnum.MY_PROJECTS"
                    [class.noCPMM]="groupedAreas?.length === 0"
                ></th>

                <th class="middle-cols-MM col3" [class.noCPMM]="groupedAreas?.length === 0"></th>

                <th class="middle-cols-MM col4" [class.noCPMM]="groupedAreas?.length === 0"></th>
                <th *ngIf="showTags" class="middle-cols-MM col5" [class.noCPMM]="groupedAreas?.length === 0"></th>

                <!-- Sticky columns: company, date, assignee, status -->
                <ng-container *ngFor="let group of groupedAreas; index as gi">
                    <th
                        [attr.colspan]="group.summaries.length"
                        class="group-header"
                        [ngClass]="{
                            'first-group': gi === 0,
                            'bg-indigo-100': gi % 2 === 0,
                            'bg-indigo-50': gi % 2 === 1
                        }"
                    >
                        {{
                            (group.area === 'MANDATE_MANAGEMENT'
                                ? 'cpmm_projects_overview_group_mandate_management'
                                : abcpClosing
                                ? 'aumico_reports_annual_report_navigation_closing'
                                : 'cpmm_projects_overview_group_closing_workflow'
                            ) | i18next
                        }}
                    </th>
                </ng-container>
                <th [class.noCPMM]="groupedAreas?.length === 0" class="group-header report bg-indigo-100">
                    {{ 'cpmm_projects_overview_group_report' | i18next }}
                </th>
                <th
                    [class.noCPMM]="groupedAreas?.length === 0"
                    class="group-header-row sticky-action bg-indigo-50"
                ></th>
                <!-- Sticky action column -->
            </tr>

            <!-- 🔤 Regular Column Headers -->
            <ng-template hamHeaderCell>
                <div class="header-text-container company" (click)="sortBy(ProjectSortingProperties.COMPANY_NAME)">
                    <div
                        class="checkbox-wrapper"
                        style="padding: 10px; cursor: pointer; display: inline-flex; align-items: center"
                        (click)="$event.stopPropagation(); onToggleCheckAllProject(); $event.stopPropagation()"
                    >
                        <span hamCheckbox [checked]="allProjectsSelected" (change)="onToggleCheckAllProject()"> </span>
                    </div>
                    {{ 'cpmm_projects_overview_col_company' | i18next }}
                    <span
                        *ngIf="activeSortBy !== ProjectSortingProperties.COMPANY_NAME"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.COMPANY_NAME)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.COMPANY_NAME && activeSortOrder === 'asc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-ascending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.COMPANY_NAME)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.COMPANY_NAME && activeSortOrder === 'desc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-descending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.COMPANY_NAME)"
                    ></span>
                </div>
            </ng-template>
            <ng-template hamHeaderCell
                ><div
                    class="header-text-container bs-date"
                    (click)="sortBy(ProjectSortingProperties.BALANCE_SHEET_DATE)"
                >
                    {{ 'cpmm_projects_overview_col_balance_sheet_date' | i18next }}
                    <span
                        *ngIf="activeSortBy !== ProjectSortingProperties.BALANCE_SHEET_DATE"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.BALANCE_SHEET_DATE)"
                    ></span>
                    <span
                        *ngIf="
                            activeSortBy === ProjectSortingProperties.BALANCE_SHEET_DATE && activeSortOrder === 'asc'
                        "
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-ascending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.BALANCE_SHEET_DATE)"
                    ></span>
                    <span
                        *ngIf="
                            activeSortBy === ProjectSortingProperties.BALANCE_SHEET_DATE && activeSortOrder === 'desc'
                        "
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-descending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.BALANCE_SHEET_DATE)"
                    ></span></div
            ></ng-template>

            <ng-template hamHeaderCell *ngIf="activeNav !== navEnum.MY_PROJECTS"
                ><div class="header-text-container person" (click)="sortBy(ProjectSortingProperties.ASSIGNEE)">
                    {{ 'cpmm_projects_overview_col_responsible' | i18next }}
                    <span
                        *ngIf="activeSortBy !== ProjectSortingProperties.ASSIGNEE"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.ASSIGNEE)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.ASSIGNEE && activeSortOrder === 'asc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-ascending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.ASSIGNEE)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.ASSIGNEE && activeSortOrder === 'desc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-descending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.ASSIGNEE)"
                    ></span></div
            ></ng-template>
            <ng-template hamHeaderCell
                ><div class="header-text-container report-type" (click)="sortBy(ProjectSortingProperties.REPORT_TYPE)">
                    {{ 'cpmm_projects_overview_col_report_type' | i18next }}
                    <span
                        *ngIf="activeSortBy !== ProjectSortingProperties.REPORT_TYPE"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.REPORT_TYPE)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.REPORT_TYPE && activeSortOrder === 'asc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-ascending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.REPORT_TYPE)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.REPORT_TYPE && activeSortOrder === 'desc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-descending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.REPORT_TYPE)"
                    ></span></div
            ></ng-template>
            <ng-template hamHeaderCell
                ><div class="header-text-container status" (click)="sortBy(ProjectSortingProperties.STATUS)">
                    {{
                        (groupedAreas?.length > 0
                            ? 'cpmm_projects_overview_col_status'
                            : 'cpmm_projects_overview_col_project_status'
                        ) | i18next
                    }}
                    <span
                        *ngIf="activeSortBy !== ProjectSortingProperties.STATUS"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.STATUS)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.STATUS && activeSortOrder === 'asc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-ascending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.STATUS)"
                    ></span>
                    <span
                        *ngIf="activeSortBy === ProjectSortingProperties.STATUS && activeSortOrder === 'desc'"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-sort-descending.svg"
                        [size]="'s'"
                        [keepOriginalColors]="'true'"
                        [variant]="'none'"
                        (click)="sortBy(ProjectSortingProperties.STATUS)"
                    ></span></div
            ></ng-template>
            <!-- REV-22155: tags of the company, only when the organization has tags -->
            <ng-template hamHeaderCell *ngIf="showTags">
                <div class="header-text-container">{{ 'cpmm_projects_overview_col_tag' | i18next }}</div>
            </ng-template>

            <ng-container *ngFor="let group of groupedAreas">
                <ng-container *ngFor="let summary of group.summaries">
                    <ng-template hamHeaderCell>
                        <ng-container *ngIf="group.area === 'CLOSING_PROCESS'; else plainSummary">
                            <span hamTooltip="{{ 'cpmm_projects_overview_header_row_' + summary | i18next }}">
                                {{ 'cpmm_projects_overview_header_row_' + summary | i18next }}
                            </span>
                        </ng-container>
                        <ng-template #plainSummary>
                            <span hamTooltip="{{ summary }}">
                                {{ summary }}
                            </span>
                        </ng-template>
                    </ng-template>
                </ng-container>
            </ng-container>

            <ng-template hamHeaderCell>{{
                (groupedAreas?.length > 0
                    ? 'cpmm_projects_overview_col_status'
                    : 'cpmm_projects_overview_col_report_status'
                ) | i18next
            }}</ng-template>

            <!--  Table Body Rows -->
            <ng-template hamCell let-element (cellClick)="onGeneralDataClicked($event.projectId)">
                <div
                    style="display: flex; align-items: center; gap: 8px"
                    [ngClass]="{
                        'parent-project-cell': element.isParentProject,
                        'child-project-cell': element.parentProjectId && !element.isParentProject,
                        selected: selectedProjects.has(element.projectId)
                    }"
                >
                    <div
                        class="checkbox-wrapper"
                        style="padding: 10px; cursor: pointer; display: flex; align-items: center"
                        (click)="onProjectCheckboxClick(element.projectId, $event)"
                    >
                        <span
                            class="checkBox"
                            hamCheckbox
                            [checked]="selectedProjects.has(element.projectId)"
                            [bubbleEvents]="true"
                        >
                        </span>
                    </div>

                    <ng-container *ngIf="element.parentProjectId && !element.isParentProject">
                        <span
                            hamIconShapes
                            icon="assets/hamIcons/turn_right.svg"
                            [size]="'lg'"
                            [variant]="'transparent'"
                        ></span>
                    </ng-container>
                    <div class="company-name">
                        <span class="company-name-text" data-testid="overview-company-name">
                            {{ element.companyName }}
                        </span>
                        <span class="badge" [class.--dark-grey]="true" *ngIf="element.label">
                            <ng-container>
                                <span>{{ element.label }}</span>
                            </ng-container>
                        </span>
                    </div>

                    <ng-container *ngIf="element.isParentProject">
                        <span
                            *ngIf="!isParentExpanded(element.projectId)"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-up-outline.svg"
                            [size]="'s'"
                            [variant]="'transparent'"
                            class="parent-project-toggle"
                            (click)="toggleParentProject(element.projectId); $event.stopPropagation()"
                        ></span>
                        <span
                            *ngIf="isParentExpanded(element.projectId)"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-down.svg"
                            [size]="'s'"
                            [variant]="'transparent'"
                            class="parent-project-toggle"
                            (click)="toggleParentProject(element.projectId); $event.stopPropagation()"
                        ></span>
                    </ng-container>
                </div>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onGeneralDataClicked($event.projectId)"
                ><span data-testid="overview-balance-date">{{
                    element.balanceSheetDate | dateLocale
                }}</span></ng-template
            >

            <ng-template
                hamCell
                let-element
                (cellClick)="onGeneralDataClicked($event.projectId)"
                *ngIf="activeNav !== navEnum.MY_PROJECTS"
            >
                <div style="position: relative; display: inline-flex; align-items: center">
                    <ham-avatar
                        style="display: inline-block; width: 35px; height: 35px; position: relative; z-index: 2"
                        type="circle"
                        variant="grey-border"
                        size="regular"
                        [class.deleted]="element.assigneeDeleted"
                        [fullName]="element.assignee === ('aumico_tasks_unassigned' | i18next) ? '-' : element.assignee"
                        hamTooltip="{{ element.assignee }}"
                    ></ham-avatar>
                    <ham-avatar
                        style="
                            display: inline-block;
                            width: 35px;
                            height: 35px;
                            position: relative;
                            z-index: 1;
                            margin-left: -12px;
                        "
                        type="circle"
                        variant="grey-border"
                        size="regular"
                        [class.deleted]="element.clerkDeleted"
                        [fullName]="element.clerk === ('aumico_tasks_unassigned' | i18next) ? '-' : element.clerk"
                        hamTooltip="{{ element.clerk }}"
                    ></ham-avatar>
                </div>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onGeneralDataClicked($event.projectId)">
                <ng-container>
                    <span
                        class="badge"
                        [class.--dark-grey]="element.reportType === 'annual' || element.reportType == null"
                        [class.--light-grey]="element.reportType !== 'annual' && element.reportType != null"
                    >
                        <ng-container [ngSwitch]="element.reportType">
                            <span *ngSwitchCase="'annual'">{{
                                'aumico_create_project_dialog_select_report_type_annual' | i18next
                            }}</span>
                            <span *ngSwitchCase="'quarterly'">{{
                                'aumico_create_project_dialog_select_report_type_quarterly' | i18next
                            }}</span>
                            <span *ngSwitchCase="'monthly'">{{
                                'aumico_create_project_dialog_select_report_type_monthly' | i18next
                            }}</span>
                            <span *ngSwitchCase="'custom'">{{
                                'aumico_create_project_dialog_select_report_type_custom' | i18next
                            }}</span>
                            <span *ngSwitchDefault>{{
                                'aumico_create_project_dialog_select_report_type_annual' | i18next
                            }}</span>
                        </ng-container>
                    </span>
                </ng-container>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onGeneralDataClicked($event.projectId)">
                <ng-container>
                    <span
                        class="badge"
                        [class.--green]="element.projectStatus === 'done'"
                        [class.--blue]="element.projectStatus === 'active'"
                    >
                        {{ 'cpmm_projects_overview_badge_' + element.projectStatus | i18next }}
                    </span>
                </ng-container>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onGeneralDataClicked($event.projectId)" *ngIf="showTags">
                <div class="project-tags">
                    <ham-tag-pill *ngFor="let tag of element.tags ?? []" [label]="tag"></ham-tag-pill>
                </div>
            </ng-template>

            <ng-container *ngFor="let group of groupedAreas">
                <ng-container *ngFor="let summary of group.summaries">
                    <ng-template
                        hamCell
                        let-element
                        (cellClick)="onSummaryClick($event.projectId, group.area, summary)"
                    >
                        <!-- ABCP: one column, whether the closing was started (same gate as the closing itself). -->
                        <span
                            *ngIf="isAbcpClosingColumn(group.area, summary) && !element.parentProjectId"
                            class="badge"
                            data-testid="project-closing-started"
                            [attr.data-status]="element.closingStartedAt ? 'started' : 'not-started'"
                            [class.--green]="!!element.closingStartedAt"
                        >
                            {{
                                (element.closingStartedAt
                                    ? 'cpmm_projects_overview_badge_closing_started'
                                    : 'cpmm_projects_overview_badge_closing_not_started'
                                ) | i18next
                            }}
                        </span>
                        <div
                            *ngIf="!element.parentProjectId && !isAbcpClosingColumn(group.area, summary)"
                            class="badge-wrapper"
                            (mouseenter)="startHover($event, element.projectId, summary)"
                            (mouseleave)="endHover()"
                        >
                            <span
                                class="badge"
                                [class.--red]="taskStatus(element, group.area, summary) === 'overdue'"
                                [class.--yellow]="taskStatus(element, group.area, summary) === 'almostOverdue'"
                                [class.--green]="taskStatus(element, group.area, summary) === 'done'"
                            >
                                {{ getSummaryBadge(element, group.area, summary) }}
                            </span>
                            <!-- Inline tooltip, only shown on hover -->
                            <span
                                *ngIf="
                                    hovered &&
                                    hoveredProjectId === element.projectId &&
                                    hoveredSummary === summary &&
                                    getSummaryTooltipIssues().length !== 0
                                "
                                class="issue-details-flyout"
                                #issueDetailsFlyout
                                hamFlyout
                                [position]="issueDetailsFlyoutPosition"
                                [disableBackdrop]="true"
                                (mouseenter)="keepFlyoutOpen()"
                                (mouseleave)="endHover()"
                            >
                                <div #issueListContainer class="issue-details-flyout-content">
                                    <ul #issueList>
                                        <li
                                            *ngFor="let item of getSummaryTooltipIssues()"
                                            class="issue-item"
                                            [class.--red]="
                                                isOverdue(item.dueDate) &&
                                                item.state !== TaskState.DONE &&
                                                group.area === 'MANDATE_MANAGEMENT'
                                            "
                                            [class.--yellow]="
                                                isDueSoon(item.dueDate) &&
                                                item.state !== TaskState.DONE &&
                                                group.area === 'MANDATE_MANAGEMENT'
                                            "
                                            [ngStyle]="{
                                                display: 'flex',
                                                'justify-content': 'space-between'
                                            }"
                                        >
                                            <span
                                                (click)="
                                                    onSummaryClick(element.projectId, group.area, summary, item.name)
                                                "
                                                >{{ item.name }}</span
                                            >
                                            <span
                                                *ngIf="item.state === TaskState.DONE"
                                                hamIconShapes
                                                icon="assets/hamIcons/check-circle.svg"
                                                [size]="'exact20'"
                                                [variant]="'all-green'"
                                                (click)="
                                                    changeItemState(
                                                        element.projectId,
                                                        group.area,
                                                        summary,
                                                        item.name,
                                                        item.issueId,
                                                        TaskState.OPEN
                                                    )
                                                "
                                            >
                                            </span>

                                            <span
                                                class="taks-icons"
                                                *ngIf="item.state !== TaskState.DONE"
                                                hamIconShapes
                                                icon="assets/hamIcons/empty-circle-outline.svg"
                                                [size]="'exact20'"
                                                [variant]="'transparent'"
                                                (click)="
                                                    changeItemState(
                                                        element.projectId,
                                                        group.area,
                                                        summary,
                                                        item.name,
                                                        item.issueId,
                                                        TaskState.DONE
                                                    )
                                                "
                                            >
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </span>
                        </div>
                    </ng-template>
                </ng-container>
            </ng-container>

            <ng-template hamCell let-element (cellClick)="onReportCellClicked($event.projectId)">
                <ng-container>
                    <span
                        class="badge"
                        [class.--blue]="element.reportStatus === 'sealed'"
                        [class.--green]="element.reportStatus === 'open'"
                    >
                        {{ 'cpmm_projects_overview_badge_report_' + element.reportStatus | i18next }}
                    </span>
                </ng-container>
            </ng-template>

            <!-- Action Column -->
            <ng-template hamMenuButton let-element>
                <div class="action-button-wrapper">
                    <ham-button
                        stopPropagation
                        #actionButtonWrapper
                        class="action-button"
                        size="xs"
                        variant="transparent"
                        icon="assets/hamIcons/dots-horizontal.svg"
                        (click)="openActionFlyout(element.projectId, actionButtonWrapper)"
                    >
                    </ham-button>
                </div>

                <span
                    class="action-menu-flyout"
                    hamFlyout
                    *ngIf="openedActionFlyoutProjectId === element.projectId"
                    [position]="actionFlyoutPosition"
                    (closeFlyout)="closeActionFlyout()"
                >
                    <div class="flyout-content">
                        <div
                            *ngIf="element.projectStatus !== ProjectStatus.DONE"
                            class="action"
                            (click)="
                                groupedAreas?.length !== 0
                                    ? onOpenAutoTaskUpdateDialog(element.projectId)
                                    : onUpdateStatus(element.projectId, ProjectStatus.DONE, false)
                            "
                        >
                            <span
                                hamIconShapes
                                icon="assets/hamIcons/check-circle-outline.svg"
                                [variant]="'transparent'"
                                [size]="'xs'"
                            >
                            </span
                            >{{ 'cpmm_projects_overview_action_change_status_to_done' | i18next }}
                        </div>
                        <div
                            *ngIf="element.projectStatus !== ProjectStatus.ACTIVE"
                            class="action"
                            (click)="onUpdateStatus(element.projectId, ProjectStatus.ACTIVE, false)"
                        >
                            <span
                                hamIconShapes
                                icon="assets/hamIcons/minus-outline.svg"
                                [variant]="'transparent'"
                                [size]="'xs'"
                            >
                            </span
                            >{{ 'cpmm_projects_overview_action_change_status_to_active' | i18next }}
                        </div>
                        <div class="action red" (click)="openProjectDeletionConfirmationDialog = true">
                            <span
                                hamIconShapes
                                icon="assets/hamIcons/trash-outline.svg"
                                [variant]="'transparent'"
                                [size]="'xs'"
                            >
                            </span
                            >{{ 'cpmm_projects_overview_action_delete_project' | i18next }}
                        </div>
                        <ham-confirm-decline-modal
                            *ngIf="openProjectDeletionConfirmationDialog"
                            (cancel)="openProjectDeletionConfirmationDialog = false"
                            (action)="onDeleteProject(element.projectId)"
                            footerAlignment="center"
                            actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
                            noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
                        >
                            <ham-general-confirm-decline-modal-body
                                [text]="'aumico_project_overview_project_deletion_confirmation_text' | i18next"
                            ></ham-general-confirm-decline-modal-body>
                        </ham-confirm-decline-modal>
                    </div>
                </span>
            </ng-template>
        </ham-table-with-actions></div
></ng-container>

<ham-confirm-decline-modal
    *ngIf="openAutoTaskUpdateDialog"
    (cancel)="onUpdateStatus(projectIdToBeChanged, ProjectStatus.DONE, false)"
    (action)="onUpdateStatus(projectIdToBeChanged, ProjectStatus.DONE, true)"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_projects_overview_status_update_modal_confirm' | i18next }}"
    noActionBtnText="{{ 'aumico_projects_overview_status_update_modal_cancel' | i18next }}"
    btnVariant="primary"
>
    <div class="ham-icon">
        <i class="check-circle-outline"></i>
    </div>
    <p class="project-update-modal-text">{{ 'aumico_projects_overview_status_update_modal_text' | i18next }}</p>
</ham-confirm-decline-modal>
